import React from 'react';
import { PropertyMeta } from 'src/pages/CompanyPage/_BLL/types';
import { DataPointGenerator } from 'src/pages/CompanyPage/ui//dataPointGenerator/DataPointGenerator';
import { Dictionaries } from 'src/pages/app/_BLL/metaDictionaries/types';
import s from './FieldGeneratorCompany.module.scss';
import { ReferenceDateField } from '../dataPointGenerator/fields/ReferenceDateField/ReferenceDateField';

interface Props {
	orderPrefix: string;
	meta: PropertyMeta;
	dictionaries: Dictionaries;
	namePrefix: string;
}

export const FieldGeneratorCompany: React.FC<Props> = (props) => {
	const {
		orderPrefix,
		meta: {
			propertyName,
			handlingType,
			displayName,
			description,
			showInHeader, // There is no header.
			dataPoints,
			requiresReferenceDate,
		},
		dictionaries,
		namePrefix,
	} = props;

	const mainDataPoint = dataPoints[0];

	// * Styles

	// * Render
	return (
		<div className={s.container}>
			<div className={s.label}>
				<span className={s.order}>{orderPrefix} </span>
				<div className={s.question}>
					<div className={s.question__text}>{displayName}</div>
					<div className={s.question__description}>{description}</div>
				</div>
			</div>

			<div className={s.fields}>
				<div className={s.field}>
					<div className={s.dataPoint}>
						{dataPoints.map((dataPoint) => (
							<DataPointGenerator
								key={dataPoint.internalName}
								propertyName={propertyName}
								datapointMeta={dataPoint}
								dictionaries={dictionaries}
								namePrefix={namePrefix}
								handlingType={handlingType}
							/>
						))}
					</div>
				</div>

				{requiresReferenceDate && (
					<ReferenceDateField
						namePrefix={namePrefix}
						propertyName={propertyName}
						internalName={mainDataPoint.internalName}
					/>
				)}
			</div>
		</div>
	);
};
